import { ComponentConsumerProps, RouteData } from "@sitecore-jss/sitecore-jss-react"
import { ICTABannerProps } from "../../components/CTA-Banner"
import { HeroProps } from "../../page-components/Hero"
import { BooleanField, ImageField } from "../../types/SitecoreAdapter"

export const RESULTS_PER_PAGE = 15;

export type TagResultResponse = {
  description: string,
  title: string, 
  thumbnail: string,
  url: string,
}

export type RelatedTag = {
  friendlyName: string,
  tagName: string
}

export type TagResultsResponse = {
  errors: {
    extensions: {
        code: string
    }
    message: string
  }
  tags: {
    tagFriendlyName: string,
    relatedTags: RelatedTag[]
    results: {
      totalCount: number,
      pageInfo: {
        endCursor: string,
        startCursor:string,
        hasNextPage: boolean,
        hasPreviousPage: boolean
      },
      items: TagResultResponse[]
    }
  }
}

// FYI!!!! graphql-request package automatically unwraps the "data" object. so even though
// the response is like this: 
//
// {
//   "data": {
//       "tags": {
//           "tagFriendlyName": "tag name",
//           "results": {
//               "totalCount": 0,
//               "pageInfo": {
//                   "endCursor": "0",
//                   "hasNextPage": true,
//                   "hasPreviousPage": false,
//                   "startCursor": "0"
//               },
//               "items": []
//           }
//       }
//   }
// }
// the type needs no data object. 

// data from sitecore layout service
export type TagResultsAdapterProps = ComponentConsumerProps & {
  route: {
    fields: {
      url: string
      hero: {
        fields: HeroProps
      }
      tpWidgetGlobalSettings: {
        fields: {
          enableTrustPilotHeroWidget: BooleanField
        }
      }
      thumbnail: ImageField,
      bottomCta: {
        fields: ICTABannerProps
      }
      tagResultsInitialData: TagResultsResponse
    }
  } & RouteData
}

// our data cache on the page itself, where we store current, and pre-fetched data. 
export type DataCache = {
  [pageNumber: number]: TagResultsResponse;
};